import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/transfer";

export default {
    /** 分页查询调拨单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询调拨单详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存调拨单（草稿） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除调拨单 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 按商品查询仓库的库存批次信息（出库明细带批次用） */
    queryStockBatchVoByProducts: (warehouseId, productIds) => axios.post({url: `/order/stock/stocktaking/queryStockBatchVoByProducts?warehouseId=${warehouseId}`, data: productIds}),
}
